var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactFon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.855,
    height: 157.855,
    viewBox: "0 0 157.855 157.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-fon",
    transform: "matrix(-0.087, -0.996, 0.996, -0.087, -4052.471, 952.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2",
    "data-name": "Differenzmenge 2",
    d: "M2.395,56.327a55.622,55.622,0,0,1-21-4.087,55.461,55.461,0,0,1-18.462-12.26A55.749,55.749,0,0,1-47.459,25.637,55.569,55.569,0,0,1-52.713,9.366a56.047,56.047,0,0,1-.117-16.932,55.6,55.6,0,0,1,5.02-16.328L-3.236,6.17,27.661,50.3A55.6,55.6,0,0,1,15.313,54.82,56.113,56.113,0,0,1,2.395,56.327ZM52.3,25.537h0L7.455-4.711-23.509-48.932A55.585,55.585,0,0,1-10.865-53.7,56.09,56.09,0,0,1,2.4-55.292a55.62,55.62,0,0,1,21,4.086,55.466,55.466,0,0,1,18.462,12.26,55.746,55.746,0,0,1,10.467,14.5A55.572,55.572,0,0,1,57.554-8a56.035,56.035,0,0,1-.009,17.1A55.566,55.566,0,0,1,52.3,25.536Z",
    transform: "translate(509.194 4189.661) rotate(50)",
    fill: "#ebeeeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 39.594,
    cy: 39.594,
    r: 39.594,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 474.705, 4148.631)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-telefon",
    transform: "translate(529.217 4175.986) rotate(95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_201",
    "data-name": "Pfad 201",
    d: "M.736,2.246a3.007,3.007,0,0,0-.137,2A36.821,36.821,0,0,0,10.784,23.81a35.839,35.839,0,0,0,19.51,10.134,3.141,3.141,0,0,0,2-.138.969.969,0,0,0,.483-.608l1.209-5.409a1.461,1.461,0,0,0-.456-1.331c-.185-.185-4.283-1.663-6.221-2.609a1.63,1.63,0,0,0-2.119.486L24.44,25.63a1.91,1.91,0,0,1-1.179.887c-1.9.481-7.765-4.922-9.041-6.2C12.9,19,7.314,12.988,7.8,11.091a1.913,1.913,0,0,1,.887-1.18c1.131-.654.826-.477,1.284-.744a1.632,1.632,0,0,0,.5-2.123,32.978,32.978,0,0,1-1.889-5.2A1.7,1.7,0,0,0,6.766.552L1.329,1.768A.963.963,0,0,0,.736,2.246Z",
    transform: "translate(0 0.013)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_202",
    "data-name": "Pfad 202",
    d: "M11.631,3.512A10.691,10.691,0,0,1,22.323,14.2",
    transform: "translate(5.607 1.517)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_203",
    "data-name": "Pfad 203",
    d: "M11.631.5A15.222,15.222,0,0,1,26.854,15.723",
    transform: "translate(5.607)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFon);
export default __webpack_public_path__ + "static/media/contact-fon.5b63f836bb1156795a88eb0b234c1489.svg";
export { ForwardRef as ReactComponent };